//Libs
import { ExistingPurchaseOrder } from "../../models/purchase-order";
import { ExistingPurchaseOrderReceipt } from "../../models/purchase-order-receipt";
import ReceiptFormDialog, { ReceiptFormValues } from "./ReceiptFormDialog";

interface Props {
  isDialogOpen: boolean;
  receipt: ExistingPurchaseOrderReceipt;
  purchaseOrder: ExistingPurchaseOrder;
  receipts: ExistingPurchaseOrderReceipt[];
  closeDialog: () => void;
  handleSave: (formValues: EditReceiptFormValues) => Promise<void>;
  loading?: boolean;
}

export type EditReceiptFormValues = ReceiptFormValues;

export default function EditReceiptDialog(props: Props) {
  // Convert the existing receipt to initial values
  const initialValues: Partial<EditReceiptFormValues> = {
    invoiceNumber: props.receipt.invoiceNumber || "",
    receivedDate: props.receipt.receivedDate.toDate(),
    receivedBy: props.receipt.receivedBy,
    receivingNotes: props.receipt.receivingNotes || "",
    lineItems: props.receipt.lineItems.map((item) => ({
      purchaseOrderItemID: item.purchaseOrderItemID,
      title: item.title,
      description: item.description,
      quantityOrdered: item.quantityOrdered,
      quantityReceived: item.quantityReceived,
      quantityRejected: item.quantityRejected,
      rejectionReason: item.rejectionReason || "",
      unitPrice: item.unitPrice,
      priceBookItemID: item.priceBookItemID,
    })),
  };

  return (
    <ReceiptFormDialog
      isDialogOpen={props.isDialogOpen}
      purchaseOrder={props.purchaseOrder}
      receipts={props.receipts}
      closeDialog={props.closeDialog}
      handleSave={props.handleSave}
      loading={props.loading}
      initialValues={initialValues}
      isEditing={true}
      editingReceiptId={props.receipt.id}
      title={`Edit Receipt for PO ${props.purchaseOrder.poNumber}`}
      submitButtonText="Update Receipt"
      busyText="Updating Receipt..."
    />
  );
}
